/**
 * Created by hernanherreros on 2019-05-27
 */

import * as React from 'react'
import styled from 'styled-components'
import { color, ColorProps, fontSize, FontSizeProps, space, SpaceProps } from 'styled-system'
import { Icon, Tooltip } from 'antd'

interface Props {
  children: any;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  color: string;
  slim: boolean;
  squared: boolean;
  inline: boolean;
  disabledMessage?: string;
}

export default class Button extends React.Component<Props> {
  static defaultProps = {
    slim: false,
    squared: false,
    inline: false,
  }

  state = {
    showSuccess: false,
  }


  success = () => {
    this.setState({ showSuccess: true })

    setTimeout(() => {
      this.setState({ showSuccess: false })
    }, 2500)
  }


  render () {
    const { showSuccess } = this.state
    const { children, onClick, disabled, color, slim, squared, inline, loading, disabledMessage } = this.props

    const successColor = '#6ce086'
    const canClick = !disabled && !showSuccess && !loading

    const tooltipProps: any = {}

    if (!disabled || !disabledMessage) {
      tooltipProps.visible = false
    }

    return (
      <Tooltip placement="top" title={disabledMessage} arrowPointAtCenter {...tooltipProps}>
        <ButtonComponent
          bg={showSuccess ? successColor : color}
          fontSize={[0, 1, 2]}
          py={slim ? [2] : []}
          onClick={() => canClick && onClick()}
          disabled={disabled}
          slim={slim}
          squared={squared}
          inline={inline}
        >
          <Content invisible={showSuccess || loading}>{children}</Content>
          {this.renderSuccess()}
          {this.renderLoading()}
        </ButtonComponent>
      </Tooltip>
    )
  }

  renderSuccess = () => {
    const { showSuccess } = this.state

    if (showSuccess) {
      return (
        <IconWrapper>
          <Icon type="check"/>
        </IconWrapper>
      )
    }
  }

  renderLoading = () => {
    const { loading } = this.props

    if (loading) {
      return (
        <IconWrapper>
          <Icon type="loading"/>
        </IconWrapper>
      )
    }
  }
}

const ButtonComponent = styled.button<ColorProps & FontSizeProps & SpaceProps & { slim: boolean, squared: boolean, inline: boolean }>`
  padding: 12px 32px;
  border: none;
  border-radius: 5px;
  color: #FFF;
  cursor: pointer;
  transition: .3s ease-in-out;
  outline: none;
  overflow: hidden;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: transparent;
    transition: .3s ease-in-out;
  }
  
  &:hover:after {
    background-color: rgba(255, 255, 255, .15);
  }
  
  &:active:after {
    background-color: rgba(0, 0, 0, .15);
  }
  
  ${({ slim }) =>  slim && `
    width: 100%;
  `}
  
  ${({squared}) => squared && `
    border-radius: 0;
  `}
  
  ${({inline}) => inline && `
    width: auto;
  `}
  
  ${color}
  ${fontSize}
  ${space}
  
  ${({ disabled }) => disabled && `
    &:after {
      background-color: rgba(255, 255, 255, .5) !important;
      cursor: not-allowed;
    }
  `}  
  
`

const Content = styled.span<any>`
  ${({ invisible }) => invisible && 'opacity: 0'}
`

const IconWrapper = styled.span<any>`
  position: absolute;
  color: #fff;
  
  top: 0;
  left: 0;
  
  width: 100%;
  height: 100%;
  
  display: flex;
  align-items: center;
  justify-content: center;
`